"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHBUI = exports["default"] = void 0;
var _react = require("react");
var context = /*#__PURE__*/(0, _react.createContext)({
  getCornerPopupPortalTarget: function getCornerPopupPortalTarget() {
    var _global$document;
    return (_global$document = global.document) === null || _global$document === void 0 ? void 0 : _global$document.body;
  },
  isHintedEllipsis: false,
  LinkComponent: undefined
});
var HBUIProvider = context.Provider;
var useHBUI = exports.useHBUI = function useHBUI() {
  return (0, _react.useContext)(context);
};
var _default = exports["default"] = HBUIProvider;
//# sourceMappingURL=HBUIProvider.js.map